export default __webpack_public_path__ + "static/media/map-2.aa7f8d1f.png";